module.exports = __webpack_public_path__ + "static/media/flag.e59bb7ca.svg";